

import { getCookies, setCookies } from '@/libs/utils';
import Vue from 'vue';
const vm = new Vue();
let wsKefuSocketUrl = 0 || getCookies('WS_CHAT_URL');

class wsSocket {
  constructor(opt) {
    this.ws = null;
    this.opt = opt || {};
    this.reconnectAttempts = 0; // 连接次数
    // this.reconnectMaxAttempts = 10; // 最大重连次数
    this.isManualClose = false; // 标记是否手动关闭
    this.eventQueue = {}; // 事件缓冲队列
    this.init(opt.key);

  }

  onOpen(key = false) {
    if (this.reconnectAttempts > 0) {
      // 重连成功之后，设置客服上线
      console.log("重连成功之后，设置客服上线");
      window.location.reload();

    }

    this.opt.open && this.opt.open();
    let that = this;

    this.reconnectAttempts = 0
    this.isManualClose = false // 重置
    // console.log('====xx', this.opt)

    that.ping();
    this.socketStatus = true;
  }

  init(key) {

    let wsUrl = '';
    if (key == 2) {
      wsUrl = wsKefuSocketUrl;
    }
    if (wsUrl) {
      this.wsUrl = wsUrl;
      this.connect()
    }
    // const out = setTimeout(() => {
    //   clearTimeout(out);
    //   window.location.reload();
    // }, 120000);
  }

  connect() {
    this.ws = new WebSocket(this.wsUrl);
    this.ws.onopen = this.onOpen.bind(this);
    this.ws.onerror = this.onError.bind(this);
    this.ws.onmessage = this.onMessage.bind(this);
    this.ws.onclose = this.onClose.bind(this);
  }

  close() {
    this.isManualClose = true; // 设置为手动关闭
    this.ws.close();
  }

  ping() {
    var that = this;
    this.timer = setInterval(function () {
      that.send({ type: 'ping' });
    }, 10000);
  }

  send(data) {
    return new Promise((resolve, reject) => {
      try {
        this.ws.send(JSON.stringify(data));
        resolve({ status: true });
      } catch (e) {
        reject({ status: false });
      }
    });
  }

  onMessage(res) {
    try {
      const { type, data } = JSON.parse(res.data);

      // 检查是否有监听器
      if (vm._events[type]) {
        // vm.$emit(type, data);
        this.opt.message && this.opt.message(res);
      } else {
        // 缓冲消息
        this.eventQueue[type] = this.eventQueue[type] || [];
        this.eventQueue[type].push(data);
      }


    } catch (e) {
      console.error('消息解析失败:', e, res.data);
      vm.$emit('error', { type: 'parse_error', error: e });
    }


  }

  onClose(e) {
    this.timer && clearInterval(this.timer);

    if (!this.isManualClose) {
      console.log('非主动断开，尝试重连...');
      this.reconnect()
    }

    this.opt.close && this.opt.close(e);
  }

  // 重连
  reconnect() {
    this.reconnectAttempts++
    setTimeout(() => {
      this.connect();
    }, 5000)
  }

  onError(e) {
    this.opt.error && this.opt.error(e);
  }

  // $on(...args) {
  //   vm.$on(...args);
  // }
  $on(event, callback) {
    // 处理缓冲的消息
    if (this.eventQueue[event]) {
      this.eventQueue[event].forEach(data => callback(data));
      delete this.eventQueue[event];
    }

    // 设置监听器
    vm.$on(event, callback);
  }
}

function createSocket(sockUrl = '', loginData) {
  if (!localStorage.getItem('chat_token')) {
    console.log('还未登录..,无需要连接!!'); return
  }

  wsKefuSocketUrl = sockUrl ? sockUrl : process.env.VUE_APP_SOCK
  setCookies('WS_CHAT_URL', process.env.VUE_APP_SOCK, 30);

  return new Promise((resolve, reject) => {
    const ws = new wsSocket({
      key: 2,
      loginData,
      open() {
        console.log('websock 打开', ws)

        resolve(ws);

      },
      error(e) {
        reject(e);
      },
      message(res) {

        const { type, data = {} } = JSON.parse(res.data);
        vm.$emit(type, data);

      },
      close(e) {
        vm.$emit('close', e);
        // reject(new Error('WebSocket 已关闭', e));
      },
    });
  });
}

// 
// export let Socket = null;
export let Socket = createSocket();
// let socketPromise = null;
// export function Socket() {
//   if (!socketPromise) {
//     socketPromise = createSocket()
//   }
//   return socketPromise
// }

// 初始化或重新连接 WebSocket, 手动重置
export function initSocket(sockUrl = '', loginData) {

  // 先关闭旧的连接（如果存在）
  if (Socket) {
    Socket = null;
  }

  // 创建新的 WebSocket 连接
  Socket = createSocket(sockUrl, loginData);

}
